const connectEmail = (value, fieldName) => {
    switch (fieldName) {
      case "name":
        return !value ? "Fullname is required" : "";
      case "phoneNo":
        return !value ? "Mobile Number is required" : "";
      case "email":
        return !value ? "Email is required" : "";
      case "message":
        return !value ? "Message is required" : "";
      default:
        return "";
    }
  };
  
  export { connectEmail };
  